/* Orders search filters reducer */

import * as Actions from '../actions';
import * as _ from 'lodash';

export interface ISearchFiltersOrdersState {
    associationId: any;
    clientId: any;
    statusId: any;
}

export const initialState: ISearchFiltersOrdersState = {
    associationId: -1,
    clientId: -1,
    statusId: -1,
};

export function searchFiltersOrdersReducer(state: ISearchFiltersOrdersState = initialState, action: any): ISearchFiltersOrdersState {
    switch (action.type) {
        case Actions.SEARCH_ORDERS_ASSOCIATION:
            return _.merge({}, state, { associationId: action.associationId });
        case Actions.SEARCH_ORDERS_CLIENT:
            return _.merge({}, state, { clientId: action.clientId });
        case Actions.SEARCH_ORDERS_STATUS:
            return _.merge({}, state, { statusId: action.statusId });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersOrdersReducer.tsx